import { useEffect } from 'react';
export const keyDownHandler = (firstElement, lastElement, e) => {
  if (e.key !== 'Tab') return;
  if (!e.shiftKey && document.activeElement === lastElement) {
    firstElement.focus();
    e.preventDefault();
  }
  if (e.shiftKey && document.activeElement === firstElement) {
    lastElement.focus();
    e.preventDefault();
  }
};
const selectors = ['a[href]', 'button:not([disabled])', 'textarea', 'input', 'select'];
export const useTrapFocus = ref => {
  useEffect(() => {
    var _ref$current, _ref$current2;
    const focusableElements = ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll(selectors.join(', '));
    const firstElement = focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements[0];
    const lastElement = focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements[focusableElements.length - 1];
    const boundKeydownHandler = keyDownHandler.bind(null, firstElement, lastElement);
    ref === null || ref === void 0 || (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.addEventListener('keydown', boundKeydownHandler);
    return () => {
      var _ref$current3;
      return ref === null || ref === void 0 || (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.removeEventListener('keydown', boundKeydownHandler);
    };
  }, [ref === null || ref === void 0 ? void 0 : ref.current]);
};